module.exports = __webpack_public_path__ + "assets/img/jp4_01.c8047d7d.jpg";